import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sum',
    standalone: true,
})
export class SumPipe implements PipeTransform {
    transform(sum: number): string {
        if (!sum) {
            sum = 0;
        }
        const sumStr = sum.toString();

        // If it's in scientific notation, expand it
        const [base, exponent] = sumStr.toLowerCase().split('e');
        let normalized = '';

        if (exponent !== undefined) {
            const exp = Number(exponent);
            let [intPart, decPart = ''] = base.split('.');
            let numStr = intPart + decPart;
            let decimalIndex = intPart.length;
            let newDecimalIndex = decimalIndex + exp;

            if (exp > 0) {
                while (numStr.length < newDecimalIndex) numStr += '0';
                normalized = numStr.slice(0, newDecimalIndex) + (newDecimalIndex < numStr.length ? '.' + numStr.slice(newDecimalIndex) : '');
            } else {
                while (decimalIndex < -exp) {
                    numStr = '0' + numStr;
                    decimalIndex++;
                }
                normalized = '0.' + '0'.repeat(-exp - decimalIndex) + numStr;
            }
        } else {
            normalized = sumStr;
        }

        // Ensure at least two decimal places
        if (!normalized.includes('.')) {
            normalized += '.00';
        } else {
            const decimalPartLength = normalized.split('.')[1].length;
            if (decimalPartLength === 1) {
                normalized += '0';
            }
        }

        return normalized;
    }
}
